import React, { useState } from 'react';
import Popup from 'reactjs-popup';
 
const ReturnToRequestorModal = ({ isOpen, onClose, onSave, onCancel }) => {
    const [comment, setComment] = useState("");
 
    const handleCommentChange = (e) => {
        setComment(e.target.value);  
    };
 
    const handleSave = () => {
        if (comment==="") alert("Please comment your decision.");
                     else onSave(comment);  
    };
 
    return (
        <Popup
            open={isOpen}
            onClose={onClose}
            contentStyle={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '20px',
                border: '1px solid #d9d7d7',
                borderRadius: '5px',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
            }}
            overlayStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                zIndex: 1040,
            }}
        >
            <div className="modal-content" style={{ color: 'darkblue' }}>
                <h5 className='popupTitle'>Return draft event to requestor</h5>
                <p className='popup-text'>
                    Please provide a reason for returning the draft to the requestor.
                </p>
                <div className="form-group">
                <label htmlFor="comment" className='text-label'>Comment</label>
                <textarea
                    id="comment"
                    rows="3"
                    placeholder=""
                    value={comment}
                    onChange={handleCommentChange}  // Attach the change handler
                    className='form-control popup-textarea'
                />
            </div>
                <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button
                        className="btn btn-cancel"
                        onClick={onCancel}
                    >
                        CANCEL
                    </button>
                    <button
                        className="btn btn-save"
                        onClick={handleSave}  // Use the local handleSave function
                    >
                        SAVE
                    </button>
                </div>
            </div>
        </Popup>
    );
};
 
export default ReturnToRequestorModal;